import React, { useEffect, useState } from "react";
import { Box, Typography, Button, CircularProgress, Alert } from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import axios from "axios";
import { useTranslation } from 'react-i18next';

export default function GroupLocalSettingsPage({ groupId, currentUser }) {
  const { t } = useTranslation();
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const isAdmin = currentUser?.role === "admin" || currentUser?.role === "superuser";

  useEffect(() => {
    async function fetchSettings() {
      try {
        const res = await axios.get(`/api/group-configs/${groupId}?prefix=local_`);
        const settingsObj = {};
        for (const item of res.data) {
          const cleanKey = item.key.replace(`group_${groupId}_local_`, "");
          settingsObj[cleanKey] = item.value;
        }
        setSettings(settingsObj);
      } catch (e) {
        setError(t('errors.loadGroupSettings'));
      } finally {
        setLoading(false);
      }
    }
    fetchSettings();
  }, [groupId, t]);

  const handleChange = (key, value) => {
    setSettings(s => ({ ...s, [key]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    setError(null);
    try {
      for (const key of Object.keys(settings)) {
        await axios.post(`/api/group-configs/${groupId}`, {
          key,
          value: settings[key],
        });
      }
    } catch (e) {
      setError(t('errors.saveGroupSettings'));
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <CircularProgress />;
  if (error) return <Alert severity="error">{error}</Alert>;

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h5" mb={2}><LanguageIcon sx={{ mr: 1, verticalAlign: "middle" }} />{t('local-settings.title')}</Typography>
      <Box mb={2}>
        <Typography variant="body1">{t('local-settings.displayLanguage')}:</Typography>
        <input
          value={settings.displayLanguage || ""}
          onChange={e => handleChange("displayLanguage", e.target.value)}
          disabled={!isAdmin}
        />
      </Box>
      <Box mb={2}>
        <Typography variant="body1">{t('local-settings.dateFormat')}:</Typography>
        <input
          value={settings.dateFormat || ""}
          onChange={e => handleChange("dateFormat", e.target.value)}
          disabled={!isAdmin}
        />
      </Box>
      {/* Ajoutez d'autres paramètres ici */}
      {isAdmin 
        ? <Button variant="contained" onClick={handleSave} disabled={saving}>
            {saving ? t('saving') : t('save')}
          </Button>
        : <Alert severity="info">{t('local-settings.adminOnly')}</Alert>}
    </Box>
  );
}
